import type { Nullable } from '@libs/core';

export type ClsxArgs = Array<Nullable<string | boolean | Array<Nullable<string | boolean>>>>;

export const clsx = (...args: ClsxArgs): string =>
    args
        .reduce((classNames: string[], arg) => {
            if (typeof arg === 'string') {
                classNames.push(arg.trim());
            } else if (Array.isArray(arg)) {
                classNames.push(clsx(...arg));
            }

            return classNames;
        }, [])
        .join(' ');
